import React from "react";
import ReactDOM from "react-dom";
// import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";
import "assets/styles/style.css";

// layouts

// import Admin from "layouts/Admin.js";
// import Auth from "layouts/Auth.js";

// views without layouts

// import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import Index from "views/Index.js";
import Login from "views/auth/Login";
import Register from "views/auth/Register";
import Dashboard from "views/admin/Dashboard";
import GetExpenseType from "components/ExpenseType/GetExpenseType";
import AddExpenseType from "components/ExpenseType/AddExpenseType";
import Settings from "views/auth/Settings";
import Expense from "components/Expense/Expense";
import ChangePassword from "components/Users/ChangePassword";
import ForgotPassword from "components/Users/ForgotPassword";
import Users from "components/Admin/Users";
import AdminDetails from "components/Admin/AdminDetails";
import Changepassword from "components/Admin/Changepassword";
import MessageThreads from "components/Email Tracker/MessageThreads";

import SettingsForAdmin from "components/Admin/SettingsForAdmin";

import adminDashboard from "components/Admin/AdminDashboard";
import AddUser from "components/Admin/AddUser";
import EditUser from "components/Admin/EditUser";
import UserDetailsbyAdmin from "components/Admin/UserDetailsbyAdmin";
import ExpenseTypeDetails from "components/ExpenseType/ExpenseTypeDetails";
import UserRegister from "views/auth/UserRegister";
import Verification from "views/auth/Verification";
import EmailVerifition from "views/auth/EmailVerifition";
import UserExpenses from "views/auth/UserExpenses";
import UpdateProfile from "components/Users/UpdateProfile";
import GetAllSubUsers from "components/SubUsers/GetAllSubUsers";
import AddSubUser from "components/SubUsers/AddSubUser";
import ViewSubUser from "components/SubUsers/ViewSubUser";
import EditSubUser from "components/SubUsers/EditSubUser";
import UpdateSubUserbyAdmin from "components/Admin/UpdateSubUserbyAdmin";
import GetAllItems from "components/Items/GetAllItems";
import Quantitytracking from "components/Items/Quantitytracking";
import PaymentTracking from "components/Items/PaymentTracking";
import AddItem from "components/Items/AddItem";
import ItemDetails from "components/Items/ItemDetails";
import NotesIndex from "components/Notes/NotesIndex";
import NoteDetails from "components/Notes/NoteDetails";
import UpdateAdminProfile from "components/Admin/UpdateAdminProfile";
import GetDocumentCategory from "components/Documents/DocumentCategory/GetDocumentCategory";
import AddDocumentCategory from "components/Documents/DocumentCategory/AddDocumentCategory";
import DocumentCategoryDetails from "components/Documents/DocumentCategory/DocumentCategoryDetails";
import GetDocuments from "components/Documents/GetDocuments";
import ViewDocuments from "components/Documents/ViewDocuments";
import GetDocumentsbyCategory from "components/Documents/DocumentCategory/GetDocumentsbyCategory";
import Landing1 from "views/Landing1";
import EmailChecker from "components/Email Tracker/EmailChecker";
import MessageLogs from "components/Email Tracker/MessageLogs";
import ViewMessageLog from "components/Email Tracker/ViewMessageLog";
import EmailServerSettings from "components/Email Tracker/EmailServerSettings";
import SendEmailReport from "components/Email Tracker/SendEmailReport";
import MarketingDashboard from "components/Email Tracker/MarketingDashboard";
import ExpenseDashboard from "components/Expense/ExpenseDashboard";
import AddExpense from "components/Expense/AddExpense";
import NewExpenseDashboard from "components/Expense/ExpenseDashboard2";
import ExpenseTreeChartDetailed from "components/NewDashboard/ExpenseTreeChartDetailed";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/landing" exact component={Landing1} />
      <Route path="/profile" exact component={Profile} />
      <Route path="/register" exact component={Register} />

      <Route path="/userRegister" exact component={UserRegister} />
      <Route path="/addexpensetype" exact component={AddExpenseType} />
      <Route path="/expenses" exact component={Expense} />
      <Route path="/expenses/add-expense" exact component={AddExpense} />
      <Route path="/expenses/:id" exact component={AddExpense} />
      <Route path="/settings" exact component={Settings} />
      <Route path="/settingsForAdmin" exact component={SettingsForAdmin} />

      <Route path="/changepassword" exact component={ChangePassword} />
      <Route path="/forgotpassword" exact component={ForgotPassword} />
      <Route path="/dashboard" exact component={Dashboard}></Route>
      <Route path="/getExpensetype" exact component={GetExpenseType}></Route>
      <Route
        path="/expensetypeDetails"
        exact
        component={ExpenseTypeDetails}
      ></Route>
      <Route path="/emailVerification" exact component={Verification}></Route>
      <Route path="/verifyEmail" exact component={EmailVerifition}></Route>
      <Route path="/userExpenses" exact component={UserExpenses}></Route>
      <Route path="/updateProfile" exact component={UpdateProfile}></Route>

      <Route path="/admindashboard" exact component={adminDashboard} />
      <Route path="/updateAdminProfile" exact component={UpdateAdminProfile} />
      <Route path="/users" exact component={Users} />
      <Route path="/login" exact component={Login} />
      <Route path="/editUsers" exact component={EditUser} />
      <Route path="/addUsers" exact component={AddUser} />
      <Route path="/viewUser" exact component={UserDetailsbyAdmin} />
      <Route path="/adminDetails" exact component={AdminDetails} />
      <Route path="/changeAdminPassword" exact component={Changepassword} />
      <Route path="/" exact component={Landing1} />

      <Route path="/notes" exact component={NotesIndex} />
      <Route path="/notes/:noteId" component={NoteDetails} />
      <Route path="/getAllItems" exact component={GetAllItems} />
      <Route path="/itemDetails" exact component={ItemDetails} />
      <Route path="/addItem" exact component={AddItem} />
      <Route path="/getQuantityTraking" exact component={Quantitytracking} />
      <Route path="/paymentTraking" exact component={PaymentTracking} />

      {/* SubUser */}
      <Route path="/getAllSubUsers" exact component={GetAllSubUsers} />
      <Route path="/addSubUsre" exact component={AddSubUser} />
      <Route path="/viewSubUser" exact component={ViewSubUser} />
      <Route path="/updateSubUser" exact component={EditSubUser} />
      <Route
        path="/updateSubUserbyAdmin"
        exact
        component={UpdateSubUserbyAdmin}
      />

      <Route
        path="/getAllDocumentCategory"
        exact
        component={GetDocumentCategory}
      />
      <Route
        path="/categoryDocuments"
        exact
        component={GetDocumentsbyCategory}
      />
      <Route
        path="/addDocumentCategory"
        exact
        component={AddDocumentCategory}
      />
      <Route
        path="/documentCategoryDetails"
        exact
        component={DocumentCategoryDetails}
      />
      <Route path="/getDocument" exact component={GetDocuments} />
      <Route path="/viewDocument" exact component={ViewDocuments} />
      <Route path="/viewMessageLog" exact component={ViewMessageLog} />
      <Route path="/emailChecker" exact component={EmailChecker} />
      <Route path="/messageLogs" exact component={MessageLogs} />
      <Route path="/messageThreads" exact component={MessageThreads} />
      <Route
        path="/emailServerSettings"
        exact
        component={EmailServerSettings}
      />
      <Route path="/sendEmailReport" exact component={SendEmailReport} />
      <Route path="/marketingDashboard" exact component={MarketingDashboard} />
      <Route path="/expenseDashboard" exact component={ExpenseDashboard} />
      <Route path="/newExpenseDashboard" exact component={NewExpenseDashboard} />
      <Route path="/detaild-tree-map" exact component={ExpenseTreeChartDetailed} />

      {/* redirect to the first page */}
      <Redirect from="*" to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

// const root = createRoot(document.getElementById("root"));

// root.render(
//   <BrowserRouter>
//     <Switch>
//       <Route path="/landing" exact component={Landing1} />
//       <Route path="/profile" exact component={Profile} />
//       <Route path="/register" exact component={Register} />

//       <Route path="/userRegister" exact component={UserRegister} />
//       <Route path="/addexpensetype" exact component={AddExpenseType} />
//       <Route path="/expenses" exact component={Expense} />
//       <Route path="/settings" exact component={Settings} />
//       <Route path="/settingsForAdmin" exact component={SettingsForAdmin} />

//       <Route path="/changepassword" exact component={ChangePassword} />
//       <Route path="/forgotpassword" exact component={ForgotPassword} />
//       <Route path="/dashboard" exact component={Dashboard}></Route>
//       <Route path="/getExpensetype" exact component={GetExpenseType}></Route>
//       <Route
//         path="/expensetypeDetails"
//         exact
//         component={ExpenseTypeDetails}
//       ></Route>
//       <Route path="/emailVerification" exact component={Verification}></Route>
//       <Route path="/verifyEmail" exact component={EmailVerifition}></Route>
//       <Route path="/userExpenses" exact component={UserExpenses}></Route>
//       <Route path="/updateProfile" exact component={UpdateProfile}></Route>

//       <Route path="/admindashboard" exact component={adminDashboard} />
//       <Route path="/updateAdminProfile" exact component={UpdateAdminProfile} />
//       <Route path="/users" exact component={Users} />
//       <Route path="/login" exact component={Login} />
//       <Route path="/editUsers" exact component={EditUser} />
//       <Route path="/addUsers" exact component={AddUser} />
//       <Route path="/viewUser" exact component={UserDetailsbyAdmin} />
//       <Route path="/adminDetails" exact component={AdminDetails} />
//       <Route path="/changeAdminPassword" exact component={Changepassword} />
//       <Route path="/" exact component={Landing1} />

//       <Route path="/notes" exact component={NotesIndex} />
//       <Route path="/notes/:noteId" component={NoteDetails} />
//       <Route path="/getAllItems" exact component={GetAllItems} />
//       <Route path="/itemDetails" exact component={ItemDetails} />
//       <Route path="/addItem" exact component={AddItem} />
//       <Route path="/getQuantityTraking" exact component={Quantitytracking} />
//       <Route path="/paymentTraking" exact component={PaymentTracking} />

//       {/* SubUser */}
//       <Route path="/getAllSubUsers" exact component={GetAllSubUsers} />
//       <Route path="/addSubUsre" exact component={AddSubUser} />
//       <Route path="/viewSubUser" exact component={ViewSubUser} />
//       <Route path="/updateSubUser" exact component={EditSubUser} />
//       <Route
//         path="/updateSubUserbyAdmin"
//         exact
//         component={UpdateSubUserbyAdmin}
//       />

//       <Route
//         path="/getAllDocumentCategory"
//         exact
//         component={GetDocumentCategory}
//       />
//       <Route
//         path="/categoryDocuments"
//         exact
//         component={GetDocumentsbyCategory}
//       />
//       <Route
//         path="/addDocumentCategory"
//         exact
//         component={AddDocumentCategory}
//       />
//       <Route
//         path="/documentCategoryDetails"
//         exact
//         component={DocumentCategoryDetails}
//       />
//       <Route path="/getDocument" exact component={GetDocuments} />
//       <Route path="/viewDocument" exact component={ViewDocuments} />
//       <Route path="/viewMessageLog" exact component={ViewMessageLog} />
//       <Route path="/emailChecker" exact component={EmailChecker} />
//       <Route path="/messageLogs" exact component={MessageLogs} />
//       <Route path="/messageThreads" exact component={MessageThreads} />
//       <Route
//         path="/emailServerSettings"
//         exact
//         component={EmailServerSettings}
//       />
//       <Route path="/sendEmailReport" exact component={SendEmailReport} />
//       <Route path="/marketingDashboard" exact component={MarketingDashboard} />
//       <Route path="/expenseDashboard" exact component={ExpenseDashboard} />

//       {/* redirect to the first page */}
//       <Redirect from="*" to="/" />
//     </Switch>
//   </BrowserRouter>
// );
